import { render } from "./칭찬합니다-리스트.vue?vue&type=template&id=42797068"
import script from "./칭찬합니다-리스트.vue?vue&type=script&lang=js"
export * from "./칭찬합니다-리스트.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__